
import './App.scss';
import { About, Header, Footer, Skills, Testimonials, Works, Certificates } from './container'
import { Navbar } from './components';

function App() {
  return (
    <div className='app'>
      <Navbar />
      <Header />
      <hr className="line" />
      <About />
      <hr className="line" />
      <Works />
      <hr className="line" />
      <Skills />
      <hr className="line" />
      <Certificates />
      <hr className="line" />
      <Testimonials />
      <hr className="line" />
      <Footer />

    </div>
  );
}

export default App;
